export default (function (_ref) {
  var request = _ref.request;
  return {
    stageWarnAdd: function stageWarnAdd(data) {
      return request({
        url: '/disease/stageWarn/add',
        method: 'post',
        data: data
      });
    },
    stageWarnModify: function stageWarnModify(data) {
      return request({
        url: "/disease/stageWarn/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    stageWarnDel: function stageWarnDel(id) {
      return request({
        url: "/disease/stageWarn/".concat(id, "/del"),
        method: 'delete'
      });
    },
    stageWarnQuery: function stageWarnQuery(data) {
      return request({
        url: '/disease/stageWarn/query',
        method: 'get',
        params: data
      });
    },
    stageWarnDetail: function stageWarnDetail(id) {
      return request({
        url: "/disease/stageWarn/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});